<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  mounted() {
    document.title = 'PhotoLink 2.0 WebApp'
  }
}
</script>